import currency from "currency.js";

export function currencyToNumber(c: currency): number {
  return c.intValue / 100;
}

export function absCurrency(c: currency): currency {
  return currency(Math.abs(currencyToNumber(c)));
}

export function negateCurrency(c: currency): currency {
  return currency(-currencyToNumber(c));
}
export function sumCurrency(cs: currency[]): currency {
  return cs.reduce((acc, c) => acc.add(c), currency(0));
}
